import React from "react";
import injectSheet from "react-jss";
import { Image, ImageMagnifier, Tile } from "../../";

const ImageTile = (props) => {
	const {
		classes,
		conflicts,
		disabled,
		handleClick,
		index,
		isSelected,
		node,
		requires,
		wide,
	} = props;

	const noOption =
		!(node.images && Array.isArray(node.images) && node.images.length > 0) &&
		!node.description;

	return (
		<div
			className={`${classes.tileContainer} ${
				isSelected && classes.selected
			} ${wide && "wide"} ${noOption && "noOption"}`}
		>
			<Tile
				conflicts={conflicts}
				disabled={disabled}
				index={index}
				isSelected={isSelected}
				onClick={() => handleClick()}
				requires={requires}
			>
				{noOption ? (
					<div className={`${classes.contentIconWrapper}`}>
						<div className={`${classes.contentIconContainer}`}>
							{node.images && Array.isArray(node.images) && (
								<div className={`${classes.imageIconContainer}`}>
									<Image
										src={process.env.REACT_APP_NOOPTION_IMAGE_PATH}
										alt={node.title}
									/>
								</div>
							)}
							<h3 className={`${classes.tileIconName}`}>{node.title}</h3>
						</div>
					</div>
				) : (
					<div className={`${classes.contentContainer}`}>
						{node.images && Array.isArray(node.images) && (
							<div className={`${classes.imageContainer}`}>
								<Image alt={node.title} fit="cover" src={node.images[0]} />
							</div>
						)}
						<div className={`${classes.textContainer}`}>
							<div className={`${classes.titleContainer}`}>
								<h3 className={`${classes.tileTitle}`}>{node.title}</h3>
								<div className={`${classes.imageMagnifier}`}>
									<ImageMagnifier elements={[{ image: node.images[0] }]} />
								</div>
							</div>
							{node.description && (
								<p className={`${classes.description}`}>{node.description}</p>
							)}
						</div>
					</div>
				)}
			</Tile>
		</div>
	);
};

const styles = (theme) => ({
	tileContainer: {
		position: "relative",
		display: "flex",
		flexWrap: "wrap",
		justifyContent: "center",
		alignItems: "center",
		width: "100%",
		height: "100%",
		"&:not(.noOption)": {
			"&:hover $textContainer": {
				transform: "translateY(-100%)",
			},
		},
		"&.noOption": {
			backgroundColor: theme.colors.main_2,
			"& $contentContainer": {
				display: "flex",
				flexWrap: "wrap",
				justifyContent: "center",
				alignItems: "center",
				width: "100%",
				height: "100%",
			},
			"& $imageContainer": {
				width: "auto",
				height: "200px",
			},
			"& $tileTitle": {
				width: "100%",
				textAlign: "center",
			},
		},
	},
	contentContainer: {
		height: "100%",
	},
	imageContainer: {
		paddingBottom: "40px",
		width: "100%",
		height: "100%",
	},
	textContainer: {
		width: "100%",
		backgroundColor: theme.colors.main_2,
		textAlign: "left",
		padding: `${theme.sizes.gutter / 2}px`,
		transform: "translateY(-40px)",
		transition: [
			{
				property: "transform",
				duration: theme.speed.fast,
			},
		],
	},
	titleContainer: {
		display: "flex",
	},
	tileTitle: {
		width: "100%",
		color: theme.colors.secondary_3b,
		marginTop: 0,
		fontSize: "16px",
	},
	description: {
		width: "100%",
		color: theme.colors.secondary_3b,
		fontSize: "12px",
		whiteSpace: "pre-line",
	},
	contentIconWrapper: {
		display: "flex",
		flexWrap: "wrap",
		justifyContent: "center",
		alignItems: "center",
		width: "100%",
		height: "100%",
	},
	contentIconContainer: {
		display: "flex",
		flexWrap: "wrap",
		justifyContent: "center",
	},
	imageIconContainer: {},
	tileIconName: {
		width: "100%",
		textAlign: "center",
	},
});

export default injectSheet(styles)(ImageTile);



// WEBPACK FOOTER //
// ./src/modules/core/components/imageTile.jsx